/* eslint-disable react/jsx-key */
import React from "react";
import PropTypes from "prop-types";
import { OrderedMap } from "immutable";
import {
    List as AntList,
    // InputNumber,
    Card,
    Row,
    Modal,
    Col,
    Input,
    message,
    // Popconfirm
} from "antd";
import { PermissionContextManager } from "hocs";
// import WordEditor from "components/word-editor";
import { formatCurrency } from "utilities/index";
import StageService from "services/stage-service";

const ListItem = AntList.Item;
const ListItemMeta = AntList.Item.Meta;

const AUTO_COMPUTED_RATIOS = (
    // onSanctionAmountChange,
    value,
    caseDetail,
    // isRiskApprover = false
) =>
    new OrderedMap({
        // sanction_limit: {
        //     label: "Sanction Limit",
        //     value: !isRiskApprover ? (
        //         <InputNumber
        //             style={{
        //                 minWidth: "200px"
        //             }}
        //             disabled={true}
        //             value={value}
        //             onChange={onSanctionAmountChange}
        //         />
        //     ) : (
        //         formatCurrency(value, true)
        //     )
        //     value: formatCurrency(value)
        // },
        proposed_limit: {
            label: "Proposed Limit",
            value: caseDetail.proposed_limit
        },
        // return_on_investment: {
        //     label: "Rate of Interest",
        //     value: caseDetail.roi
        // },
        tenure: {
            label: "Tenure",
            value: caseDetail.tenure
        },
        sanction_remarks: {
            label: "Sanction Remarks",
            value: caseDetail.sanction_remarks
        }
    });

class FinalLimitApprovalList extends React.Component {
    state = {
        sanctionAmount:
            this.props.caseDetail && this.props.caseDetail.sanction_limit &&
            +this.props.caseDetail.sanction_limit > 0
                ? this.props.caseDetail.sanction_limit
                : this.props.caseDetail && this.props.caseDetail.proposed_limit
                    ? this.props.caseDetail.proposed_limit
                    : 0,
        sanctionRemarks:
            this.props.caseDetail && this.props.caseDetail.sanction_remarks
                ? this.props.caseDetail.sanction_remarks
                : "",
        approveStage: null,
        referStage: null,
        toggleReferModal: false,
        referText: null,
        toggleSanctionModal: false,
        sanctionText: null
    };
    onSanctionAmountChange = value =>
        this.setState({
            sanctionAmount: value
        });
    onSanctionRemarksChange = value =>
        this.setState({
            sanctionRemarks: value
        });
    // updateSanctionLimit = () => {
    //     this.props.updateCaseDetail(
    //         this.props.caseDetail
    //             .set("limit_applied", this.state.sanctionAmount)
    //             .set("sanction_remarks", this.state.sanctionRemarks)
    //     );
    // };

    componentDidMount() {
        StageService.getStages(
            this.props.stageId,
            "proceed",
            this.props.caseId
        ).then(_ => this.setState({ approveStage: _.data[0] }));
        StageService.getStages(
            this.props.stageId,
            "refer",
            this.props.caseId
        ).then(_ => {
            this.setState({ referStage: _.data[0] });
        });
    }

    approveCase = () => {
        if (this.state.sanctionAmount) {
            this.props.approveCase(
                this.props.caseTaskId,
                this.props.caseId,
                this.state.approveStage.id,
                this.state.approveStage.user_list[0].id,
                this.props.caseDetail
                    .set("sanction_limit", this.state.sanctionAmount)
                    .set("sanction_remarks", this.state.sanctionText),
                this.props.stageId,
                this.props.stageName,
                this.props.user,
                this.props.stage
            );
        }
        if (
            !this.state.sanctionAmount ||
            this.state.sanctionAmount === "0.00"
        ) {
            message.error("Sanction Amount cannot be 0");
        }
        // if (!this.state.sanctionRemarks) {
        //     message.error("Please put some remarks");
        // }
    };

    referCase = () => {
        this.openReferModal();
    };

    submitCase = () => {
        this.props.referCase(
            this.props.caseTaskId,
            this.state.referStage.id,
            this.state.referStage.user_list[0].id,
            this.state.referText,
            this.props.stageName,
            this.props.stageId,
            false
        );
    };

    openReferModal = () => {
        this.setState({
            toggleReferModal: true
        });
    };

    closeReferModal = isTrue => {
        this.setState(
            {
                toggleReferModal: false
            },
            () => {
                if (isTrue) {
                    this.submitCase();
                }
            }
        );
    };

    openSanctionModal = () => {
        this.setState({
            toggleSanctionModal: true
        });
    };

    closeSanctionModal = isTrue => {
        this.setState(
            {
                toggleSanctionModal: false
            },
            () => {
                if (isTrue) {
                    this.approveCase();
                }
            }
        );
    };

    render() {
        return (
            <React.Fragment>
                <Modal
                    destroyOnClose={true}
                    closable={false}
                    visible={this.state.toggleReferModal}
                    onOk={this.closeReferModal.bind(null, true)}
                    onCancel={this.closeReferModal.bind(null, false)}
                >
                    <Input.TextArea
                        placeholder={"Please Enter Refer Remarks here..."}
                        onChange={val => {
                            this.setState({
                                referText: val.target.value
                            });
                        }}
                        autosize={{ minRows: 2, maxRows: 3 }}
                    />
                </Modal>
                <Modal
                    destroyOnClose={true}
                    closable={false}
                    visible={this.state.toggleSanctionModal}
                    onOk={this.closeSanctionModal.bind(null, true)}
                    onCancel={this.closeSanctionModal.bind(null, false)}
                >
                    <Input.TextArea
                        placeholder={"Please Enter Sanction Remarks here..."}
                        onChange={val => {
                            this.setState({
                                sanctionText: val.target.value
                            });
                        }}
                        autosize={{ minRows: 2, maxRows: 3 }}
                    />
                </Modal>
                <Card
                    className={"padless-card h-100"}
                    title={"Case Sanction"}
                    // extra={
                    //     this.props.isUserAllowedToEdit
                    //     && (!this.props.isRiskApprover || this.props.SUMMARY_EDIT)
                    //         ? [
                        
                    // }
                >
                    <Row>
                        {/* <Col span={16} className={"p-5"}>
                            <div
                                className={
                                    "d-flex flex-column align-items-flex-end"
                                }
                            >
                                <WordEditor
                                    readOnly={
                                        this.props.isRiskApprover ||
                                        !this.props.SUMMARY_EDIT
                                    }
                                    value={this.state.sanctionRemarks}
                                    onEdit={this.onSanctionRemarksChange}
                                    placeholder={"Add Specific Remarks"}
                                />
                            </div>
                        </Col> */}
                        <Col span={24} className={"p-5"}>
                            <AntList
                                itemLayout={"horizontal"}
                                dataSource={AUTO_COMPUTED_RATIOS(
                                    // this.onSanctionAmountChange,
                                    this.state.sanctionAmount,
                                    this.props.caseDetail,
                                    this.props.isRiskApprover
                                )
                                    .toList()
                                    .toArray()}
                                renderItem={item => (
                                    <ListItem key={item.label}>
                                        <ListItemMeta title={item.label} />
                                        <div>
                                            {item.label === "Proposed Limit"
                                                ? formatCurrency(
                                                    item.value,
                                                    true
                                                )
                                                : item.value}
                                        </div>
                                    </ListItem>
                                )}
                            />
                        </Col>
                    </Row>
                </Card>
            </React.Fragment>
        );
    }
}

FinalLimitApprovalList.propTypes = {
    history: PropTypes.object,
    stageId: PropTypes.number,
    caseId: PropTypes.number,
    caseTaskId: PropTypes.number,
    caseDetail: PropTypes.object,
    // updateCaseDetail: PropTypes.func,
    approveCase: PropTypes.func,
    referCase: PropTypes.func,
    getActionModal: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    SUMMARY_EDIT: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool,
    stageName: PropTypes.string,
    stage: PropTypes.object,
    user: PropTypes.object
};

export default PermissionContextManager({
    permission: "credit_summary_view",
    propsPermissions: {
        SUMMARY_EDIT: "credit_summary_edit"
    }
})(FinalLimitApprovalList);
